import { TFunction } from 'i18next'
import { UserFragment } from 'src/api/api.generated'

export default function getUserAudit({ userId, users, t }: { userId: string; users: UserFragment[]; t: TFunction }) {
  if (userId?.startsWith('lambda')) {
    return t('pms.audits.grid.user.system')
  }
  if (userId === 'UNKNOWN') {
    return t('pms.audits.grid.user.unknown')
  }
  if (userId === 'REST') {
    return t('pms.audits.grid.user.rest')
  }

  const user = users.find((userToCheck) => userToCheck.tsId === userId)

  if (user) return user.fullname

  return userId ?? ''
}
